import React from 'react';
import PropTypes from 'prop-types';
import { Alert, Box, Grid, IconButton, PasteIcon } from '@availity/element';
import { useAppContext } from '@/context';

function BackupCodeDisplay({ backupCodes = [] }) {
  const { addMessage } = useAppContext();

  async function handleCopy(code) {
    try {
      await navigator.clipboard.writeText(code);
      addMessage({
        type: 'success',
        text: `Copied ${code} successfully!`,
        icon: 'icon-attention-circle',
        timeout: 5 * 1000, // 5 seconds
        dismissible: true,
      });
    } catch (error) {
      if (error) {
        addMessage({
          type: 'danger',
          text: 'Failed to copy the secret key. Please try again.',
          icon: 'icon-attention-circle',
          timeout: 5 * 1000, // 5 seconds
          dismissible: true,
        });
      }
    }
  }

  return backupCodes.map((code) => (
    <Grid display="flex" size={{ xs: 12 }} key={code}>
      <Grid size={{ xs: 10 }}>
        <Alert
          display="flex"
          icon={false}
          severity="info"
          sx={{ padding: 2, marginBottom: 2, marginX: 1, justifyContent: 'center' }}
        >
          <Box sx={{ fontWeight: 'bold' }}>{code}</Box>
        </Alert>
      </Grid>
      <Grid size={1}>
        <IconButton title="Copy Backup Code" onClick={() => handleCopy(code)}>
          <PasteIcon />
        </IconButton>
      </Grid>
    </Grid>
  ));
}

BackupCodeDisplay.propTypes = {
  backupCodes: PropTypes.arrayOf(PropTypes.string),
};

export default BackupCodeDisplay;
